import { Box } from "@mui/material";

const barStyle = {
  width: "4px",
  height: "20px",
  backgroundColor: "#1976d2",
  margin: "0 2px",
  animation: "wave 1.2s infinite ease-in-out",
};

const VoiceWave = ({ active = true }: { active?: boolean }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "40px",
        mt: 1,
        visibility: active ? "visible" : "hidden",
      }}
    >
      {[0, 1, 2, 3, 4].map((i) => (
        <Box
          key={i}
          sx={{
            ...barStyle,
            animationDelay: `${i * 0.1}s`,
            "@keyframes wave": {
              "0%, 100%": { height: "20px" },
              "50%": { height: "40px" },
            },
          }}
        />
      ))}
    </Box>
  );
};

export default VoiceWave;
